export default __webpack_public_path__ + "static/media/Makro - Mahtumkuli.fa91bc74.jpg";